import React from 'react';
import {Container} from 'react-bootstrap';
import {Link} from 'react-router-dom';
import ItemSyncCheck from './ItemSyncCheck';
import DynamicBreadcrumb from '../header/breadcrumb';

export default function ItemSyncCheckPage() {
  return <Container className="mt-4 mb-4">
    <DynamicBreadcrumb pathArray={[{name: 'Reports', url: ''}, {name: 'GoFrugal Sync Audit', url: '/admin/gofrugal-sync'}, {name: 'Item Sync Check', url: ''}]} />
    <Link to="/admin/gofrugal-sync" className="btn btn-outline-secondary btn-sm mb-3">Back to sync audit</Link>
    <ItemSyncCheck />
  </Container>;
}
